<script>
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import {computed, ref, watch} from "vue";
import WorkerBalance from "@/views/Worker/Components/WorkerBalance.vue";
import AllPaySlipDetails from "@/views/PaySlip/Components/AllPaySlipDetails.vue";
import {useSecurityStore} from "@/stores/Security";
import {usePaySlipStore} from "@/stores/PaySlip";
import useSharedMethod from "@/use/SharedMethod";
import PaymentHistory from "@/views/PaySlip/Components/PaymentHistory.vue";
import WorkerPaySlip from "@/views/PaySlip/Components/WorkerPaySlip.vue";
import {storeToRefs} from "pinia";
import Correction from "@/views/PaySlip/Components/Correction.vue";
import axios from "axios";

export default {
    name: "PaySlipDetails",
    components: {Correction, WorkerPaySlip, PaymentHistory, AllPaySlipDetails, WorkerBalance},
    props: {
        id: Number,
        backPath: String,
        readonly: Boolean,
    },
    setup(props, {emit}) {
        const {$swal} = useTools();
        const {priceFormat} = useSharedMethod();
        const {loading, backgroundColor} = useSharedData();
        const securityStore = useSecurityStore();
        const paySlipStore = usePaySlipStore();
        
        const {paySlip} = storeToRefs(paySlipStore);
        
        const variables = computed(() => paySlip.value.details.filter(detail => detail.position === 'VARIABLE' && detail.selected))
        const fixes = computed(() => paySlip.value.details.filter(detail => detail.position === 'FIX' && detail.selected))
        const result = computed(() =>
            paySlip.value.details
                .filter(detail => detail.position === 'RESULT' && detail.selected)
                .sort((a, b) => a.paySectionOrdre - b.paySectionOrdre)
        );
        
        function findById() {
            loading.value = true;
            axios.get(`/payments/${props.id}`).then(response => {
                paySlip.value = response.data;
            }).finally(() => {
                loading.value = false;
            })
        }
        
        function calculate() {
            loading.value = true;
            axios.put(`/payments/calculate/${props.id}`).then((response) => {
                paySlip.value = response.data;
                paySlipStore.updatePaySlip(paySlip.value);
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function splitAndMergePaySection(split) {
            loading.value = true;
            const url = `/payments/splitAndMergePaySection/${props.id}`;
            axios.put(url, null, {
                params: {
                    position: paySectionPositions[tab.value],
                    split: split,
                }
            }).then((response) => {
                paySlip.value = response.data;
                paySlipStore.updatePaySlip(paySlip.value);
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function shiftForwardAndBackward(line, shiftForward) {
            loading.value = true;
            const url = `/payments/shiftForwardAndBackward/${props.id}`;
            axios.put(url, null, {
                params: {
                    position: paySectionPositions[tab.value],
                    line: line,
                    shiftForward: shiftForward,
                }
            }).then((response) => {
                paySlip.value = response.data;
                paySlipStore.updatePaySlip(paySlip.value);
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function setValue(detail) {
            loading.value = true;
            axios.put(`/payments/setValue/${detail.id}`, null, {
                params: {
                    value: detail.value,
                },
            }).then(() => {
                calculate();
            });
        }
        
        function removePaySection(detail) {
            loading.value = true;
            axios.put(`/payments/removePaySection/${props.id}/${detail.code}`).then(() => {
                calculate();
            });
        }
        
        function showValue(item) {
            return item.calculated ? "Calculé" : priceFormat(item.value);
        }
        
        
        const paySectionPositions = ['FIX', 'VARIABLE', 'RESULT'];
        const tab = ref(0);
        const ordre = ref(0);
        const pay_section_select_dialog = ref(false);
        const selected_pay_section = ref([]);
        
        
        function addPaySections() {
            loading.value = true;
            pay_section_select_dialog.value = false;
            const pay_sections = [];
            selected_pay_section.value.forEach((element) => {
                pay_sections.push({
                    paySectionCode: element.code,
                    result: element.result,
                    position: element.position ? element.position : paySectionPositions[tab.value],
                    ordre: ordre.value
                });
            });
            
            
            axios.put(`/payments/addPaySections/${props.id}`, pay_sections).then(response => {
                selected_pay_section.value = [];
                paySlip.value = response.data;
                paySlipStore.updatePaySlip(paySlip.value);
                // calculate();
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function setDescription() {
            axios.put(`/payments/setDescription/${props.id}`, null, {
                params: {description: paySlip.value.description},
            }).then(() => {
                $swal.fire('Commentaire mise à jour avec succès', '', 'success');
            });
        }
        
        function addPaySectionsWithoutSelectOrdre() {
            if (tab.value !== 2) {
                setOrdre();
                pay_section_select_dialog.value = true;
            }
        }
        
        function addPaySectionsWhenSelectOrdre(index) {
            if (tab.value !== 2) {
                ordre.value = index;
                pay_section_select_dialog.value = true;
            }
        }
        
        function setSpecificOrdre(index) {
            ordre.value = index;
        }
        
        function setOrdre() {
            const inputData = paySlip.value.details.filter(detail => detail.position === paySectionPositions[tab.value] && detail.selected);
            let obj = inputData.reduce((maxObject, currentObject) => {
                return currentObject.ordre > maxObject.ordre ? currentObject : maxObject;
            }, inputData[0]);
            ordre.value = obj ? obj.ordre + 1 : 0;
        }
        
        function closeDialog() {
            pay_section_select_dialog.value = false;
        }
        
        function getItems(items) {
            let result = [];
            let i = 0;
            while (i < 20 && result.length <= 20) {
                const filterResult = items.filter(item => item.ordre === i);
                if (filterResult.length > 0) {
                    filterResult.forEach(item => {
                        result.push(item);
                    });
                } else {
                    result.push('empty');
                }
                i++;
            }
            return result;
        }
        
        function previous() {
            emit('previous');
        }
        
        function isUpdatable(paySlip) {
            return paySlip.updateOption && !paySlip.closed && tab.value !== 2;
        }
        
        function next() {
            emit('next');
        }
        
        watch(() => props.id, () => {
            if (props.id) {
                findById();
            } else {
                paySlip.value = {details: []};
            }
        }, {immediate: true});
        
        return {
            securityStore,
            loading,
            backgroundColor,
            paySectionPositions,
            tab,
            paySlip,
            variables,
            fixes,
            result,
            calculate,
            removePaySection,
            setValue,
            showValue,
            getItems,
            previous,
            next,
            splitAndMergePaySection,
            shiftForwardAndBackward,
            pay_section_select_dialog,
            selected_pay_section,
            addPaySectionsWithoutSelectOrdre,
            addPaySections,
            setSpecificOrdre,
            closeDialog,
            addPaySectionsWhenSelectOrdre,
            setDescription,
            isUpdatable,
            priceFormat
        }
    },
}
</script>

<template>
    <div>
        <v-row dense v-show="id">
            <v-col cols="12" md="6">
                <v-card>
                    <v-card-actions v-if="paySlip.id">
                        <h2>
                            <v-icon
                                v-if="paySlip.closed"
                                left
                                color="grey darken-2"
                            >
                                mdi-lock
                            </v-icon>
                            {{ paySlip.workerName }}
                            <w-btn-icon
                                v-if="securityStore.authorities['UPDATE_WORKER']"
                                icon="mdi-pencil-circle-outline"
                                color="orange"
                                @press="$router.push({name: 'pay_slips.workers.edit',params: {id: paySlip.workerId, backPath: 'pay_slips'}})"
                            />
                            <w-btn-icon
                                v-if="securityStore.authorities['READ_WORKER']"
                                icon="mdi-account-circle-outline"
                                color="blue darken-2"
                                @press="$router.push({name: 'pay_slips.workers.view', params: {id: paySlip.workerId, backPath: 'pay_slips'}})"
                            />
                        </h2>
                        <v-spacer/>
                        <w-btn-icon
                            icon="mdi-chevron-left-box"
                            color="blue"
                            :tooltip="$t('common.back')"
                            large
                            @press="previous"
                        />
                        <w-btn-icon
                            icon="mdi-chevron-right-box"
                            color="blue"
                            :tooltip="$t('common.next')"
                            large
                            classe="ml-n3"
                            @press="next"
                        />
                        <w-btn-icon
                            v-if="securityStore.authorities.UPDATE_PAY_SLIP && paySlip.updateOption && !paySlip.closed"
                            icon="mdi-calculator-variant"
                            color="cyan"
                            :tooltip="$t('common.next')"
                            :loading="loading"
                            large
                            classe="ml-n3"
                            @press="calculate"
                        />
                        <w-btn-icon
                            v-if="paySlip.updateOption && !paySlip.closed && tab !== 2"
                            icon="mdi-plus-circle-outline"
                            color="teal"
                            :tooltip="$t('common.add')"
                            :loading="loading"
                            large
                            classe="ml-n3"
                            @press="addPaySectionsWithoutSelectOrdre"
                        />
                        <w-btn-icon
                            icon="mdi-checkbox-blank-outline"
                            color="blue"
                            tooltip="Paie a Blanc"
                            :loading="loading"
                            large
                            classe="ml-n3"
                            @press="$router.push({name: 'pay_slips.blank.view', params: {id: paySlip.id}})"
                        />
                        
                        <v-menu
                            v-if="paySlip.updateOption"
                            offset-y
                            right
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    large
                                    icon
                                    class="ml-n3 mr-n3"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon color="blue">mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item
                                    :disabled="paySlip.closed"
                                    @click="splitAndMergePaySection(true)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="blue darken-2">mdi-table-split-cell</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ $t('pay_slip.split_pay_section') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    :disabled="paySlip.closed"
                                    @click="splitAndMergePaySection(false)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="blue darken-2">mdi-table-merge-cells</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ $t('pay_slip.merge_pay_section') }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-card-actions>
                </v-card>
                <v-tabs
                    v-model="tab"
                    dense
                    height="35"
                    fixed-tabs
                    color="teal"
                    :background-color="backgroundColor"
                >
                    <v-tab
                        v-for="t in ['FIX', 'VARIABLE']"
                        :key="`tab-${t}`"
                    >
                        {{ $t(`common.${t}`) }}
                    </v-tab>
                    <v-tab>
                        {{ $t(`common.RESULT`) }}
                    </v-tab>
                    <v-tab-item
                        v-for="t in ['FIX', 'VARIABLE']"
                        :key="`tab-item-${t}`"
                    >
                        <v-card flat>
                            <v-card-text>
                                <v-simple-table dense fixed-header height="370" style="border-collapse: collapse; border: 1px solid black; ">
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th class="text-left" style="width: 0;"></th>
                                            <th class="text-left" style="width: 0;">
                                                {{ $t("common.code") }}
                                            </th>
                                            <th class="text-left">
                                                {{ $t("common.label") }}
                                            </th>
                                            <th class="text-left">
                                                {{ $t("common.value") }}
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template
                                            v-for="(detail, index) in getItems(paySlip.details.filter(d => d.position === t && d.selected))"
                                        >
                                            <tr
                                                :key="`full-fix-${index}`"
                                                v-if="detail !== 'empty'"
                                            >
                                                <td class="text-left" style="width: 0;">
                                                    <v-menu
                                                        offset-y
                                                        right
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn
                                                                icon
                                                                class="ml-n3 mr-n3"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                <v-icon color="blue">mdi-dots-vertical</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <v-list dense>
                                                            <v-list-item
                                                                :disabled="!isUpdatable(paySlip)"
                                                                @click="shiftForwardAndBackward(index, true)"
                                                            >
                                                                <v-list-item-icon>
                                                                    <v-icon color="blue darken-2">mdi-table-split-cell</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-title>{{ $t('common.add_element') }}</v-list-item-title>
                                                            </v-list-item>
                                                            <v-list-item
                                                                :disabled="!isUpdatable(paySlip)"
                                                                @click="removePaySection(detail)"
                                                            >
                                                                <v-list-item-icon>
                                                                    <v-icon color="red">mdi-trash-can</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-title>{{ $t('common.remove_element') }}</v-list-item-title>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                </td>
                                                <td style="width: 0;">
                                                    <w-tooltip
                                                        :label="detail.code"
                                                        :tooltip="detail.formule"
                                                    />
                                                </td>
                                                <td>
                                                    {{ detail.label }}
                                                </td>
                                                
                                                <td>
                                                    <w-edit-dialog
                                                        v-model="detail.value"
                                                        price-format
                                                        hide-chip
                                                        hide-details
                                                        :readonly="!isUpdatable(paySlip)"
                                                        @save="setValue(detail)"
                                                    />
                                                </td>
                                            </tr>
                                            <tr
                                                class="emptytr"
                                                :key="`empty-fix-${index}`"
                                                @dblclick="isUpdatable(paySlip) ? addPaySectionsWhenSelectOrdre(index) :  null"
                                                v-else
                                            >
                                                <td style="width: 0;">
                                                    <v-menu
                                                        v-if="isUpdatable(paySlip)"
                                                        offset-y
                                                        right
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn
                                                                icon
                                                                class="ml-n3 mr-n3"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                <v-icon color="blue">mdi-dots-vertical</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <v-list dense>
                                                            <v-list-item
                                                                @click="shiftForwardAndBackward(index, true)"
                                                            >
                                                                <v-list-item-icon>
                                                                    <v-icon color="blue darken-2">mdi-table-split-cell
                                                                    </v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-title>{{ $t('common.add_element') }}</v-list-item-title>
                                                            </v-list-item>
                                                            <v-list-item
                                                                @click="shiftForwardAndBackward(index, false)"
                                                            >
                                                                <v-list-item-icon>
                                                                    <v-icon color="red">mdi-trash-can</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-title>{{ $t('common.remove_element') }}</v-list-item-title>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                </td>
                                                <td style="width: 0;">
                                                    <input-pay-section-component
                                                        v-if="isUpdatable(paySlip)"
                                                        :selected="selected_pay_section"
                                                        @save="addPaySections"
                                                        @selecteOrdre="setSpecificOrdre(index)"
                                                    />
                                                </td>
                                                <td colspan="2"></td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item eager>
                        <v-container fluid>
                            <v-simple-table dense fixed-header height="400">
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-left" style="width: 0;">{{ $t('common.code') }}</th>
                                        <th class="text-left">{{ $t('common.name') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    
                                    <tr
                                        v-for="(item, index) in result"
                                        :key="`full-RESULT-${index}`"
                                    >
                                        
                                        <td style="width: 0;">
                                            <w-tooltip
                                                :label="item.code"
                                                :tooltip="item.formule"
                                            />
                                        </td>
                                        
                                        <td>{{ item.label }}</td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-container>
                    </v-tab-item>
                </v-tabs>
            </v-col>
            <v-col cols="12" md="6">
                <v-simple-table
                    dense
                    height="60"
                    class="paySlipResume"
                >
                    <tbody>
                    <tr>
                        <td style="background-color: #0096881a">
                            {{ $t('pay_slip.total_earnings') }}
                            <h2 class="teal--text">{{ priceFormat(paySlip.totalGains) }}</h2>
                        </td>
                        <td style="background-color: #F443361a">
                            {{ $t('pay_slip.total_restraint') }}
                            <h2 class="red--text">{{ priceFormat(paySlip.totalRetenues) }}</h2>
                        </td>
                        <td style="background-color: #2196F31a">
                            {{ $t('pay_slip.net_to_pay') }}
                            <h2 class="blue--text">
                                {{ priceFormat(paySlip.net) }}
                            </h2>
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>
                <v-tabs
                    dense
                    fixed-tabs
                    color="teal"
                    height="35"
                    background-color="grey lighten-4"
                >
                    <v-tab>{{ $t("pay_slip.bulletin") }}</v-tab>
                    <v-tab>{{ $t('common.comment') }}</v-tab>
                    <v-tab>{{ $t('pay_slip.correction') }}</v-tab>
                    <v-tab>{{ $t('pay_slip.params') }}</v-tab>
                    <v-tab>{{ $t("pay_slip.history") }}</v-tab>
                    <v-tab>{{ $t('pay_slip.all') }}</v-tab>
                    <v-tab>{{ $t('pay_slip.balance') }}</v-tab>
                    <v-tab-item>
                        <v-card>
                            <v-card-text>
                                <pay-slip-component
                                    :pay_slip="paySlip"
                                    hide-detail
                                />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <w-simple-text-area
                                    v-model="paySlip.description"
                                    :disabled="paySlip.closed"
                                />
                            </v-card-text>
                            <v-divider/>
                            <v-card-actions>
                                <v-spacer/>
                                <w-btn-apply
                                    show
                                    :disabled="paySlip.closed"
                                    @press="setDescription"
                                />
                            </v-card-actions>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <correction :pay-slip-id="paySlip.id"/>
                    </v-tab-item>
                    <v-tab-item>
                        <worker-pay-slip :worker-id="paySlip.workerId"/>
                    </v-tab-item>
                    <v-tab-item>
                        <payment-history :worker-id="paySlip.workerId"></payment-history>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card>
                            <v-card-text>
                                <all-pay-slip-details :paySlip="paySlip"/>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <worker-balance
                            :workerId="paySlip.workerId"
                            root-path="pay_slips.balance"
                        />
                    </v-tab-item>
                </v-tabs>
            </v-col>
        </v-row>
        <select-pay-section-component
            :dialog="pay_section_select_dialog"
            :selected="selected_pay_section"
            @save="addPaySections"
            @close="closeDialog"
        ></select-pay-section-component>
    </div>
</template>

<style scoped>
.emptytr {
    cursor: default;
    background-color: #FFE0B2;
}

.emptytr:hover {
    cursor: pointer;
}
</style>